module.exports = __webpack_public_path__ + "img/analytics-cmbs-intel-lead-generation-2.da4c0af3.png";